import { type ComponentType } from "react";
import { twMerge } from "tailwind-merge";
import { LoaderIcon } from "@components/icons";

interface ICustomerDetailsMenuButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ComponentType<React.SVGProps<SVGSVGElement>>;
  isLoading?: boolean;
}

export const CustomerDetailsMenuButton: React.FC<
  ICustomerDetailsMenuButtonProps
> = (props) => {
  const { icon: Icon, className, children, isLoading, ...rest } = props;

  return (
    <button
      className={twMerge(
        "flex items-center gap-2 rounded-full px-4 py-2 transition-colors hover:bg-base-light-grey",
        className,
      )}
      {...rest}
    >
      {Icon && !isLoading && <Icon className="size-4 text-grey-dark" />}
      {isLoading && (
        <LoaderIcon className="size-4 animate-spin text-grey-dark" />
      )}
      {children}
    </button>
  );
};
